import React from 'react';

import {DeviceViewModel} from "../../../models/device.view-model";
import {ScoresSectionPlaceholder} from "./scores.section.placeholder";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ScoresListHeaderModulePlaceholder} from "../../../../modules/scores-list-header-module/components/scores-list-header-module.placeholder";
import {AppTerms} from "../../../app/app-terms";
import {WithDevice} from "../../composers/with-device";

export class ScoresPlaceholderProps extends BaseProps {
  i18n: AppTerms;
  shouldHideHeader: Boolean = false;
  device: DeviceViewModel;
}

export const ScoresPlaceholder = WithDevice((props: ScoresPlaceholderProps) => {
  const sections: Array<Object> = [{key: 0}, {key: 1}, {key: 2}];

  return (
    <div className={props.className}>
      {
        !props.shouldHideHeader && <ScoresListHeaderModulePlaceholder device={props.device}/>
      }
      <div className={'scores-placeholder'}>
        {
          sections.map((sectionProps) => <ScoresSectionPlaceholder key={sectionProps.key} {...props}/>)
        }
      </div>
    </div>
  )
});
